import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { openCookiePreferences } from "./CookieBanner";
import { useLang } from "../i18n/LangContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="px-6 md:px-12 pt-24 pb-10 overflow-hidden">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <LogoMark className="w-14 h-14" />
          <p className="mt-6 eyebrow">{t.footer.tag}</p>
          <p className="mt-2 font-display italic text-2xl">A House of Ideas.</p>
        </div>
        <nav className="md:col-span-3" aria-label={t.footer.services} data-testid="footer-services-nav">
          <p className="font-display text-2xl">{t.footer.services}</p>
          <ul className="mt-3 space-y-1.5">
            {t.services_data.flatMap((g) => g.items).map((it) => (
              <li key={it.slug}>
                <Link to={`/services/${it.slug}`} data-testid={`footer-service-${it.slug}`} className="text-stone text-sm hover:text-gold transition-colors duration-300">{it.name}</Link>
              </li>
            ))}
          </ul>
        </nav>
        {t.houses.list.map((h) => (
          <div key={h.city} className="md:col-span-1 md:min-w-[7rem]" data-testid={`footer-office-${h.city}`}>
            <p className="font-display text-2xl">{h.city}</p>
            <p className="mt-3 text-stone text-sm">[{t.footer.placeholder}]</p>
          </div>
        ))}
      </div>
      <div className="mt-20 font-display text-[19vw] leading-[0.85] tracking-tight text-[var(--bone)] select-none" aria-hidden="true">
        Allure<em className="text-gold">.</em>
      </div>
      <div className="mt-10 pt-6 border-t border-line flex flex-col md:flex-row gap-4 justify-between font-mono text-xs tracking-[0.15em] uppercase text-stone">
        <span>© {new Date().getFullYear()} ALLURE HOUSE — {t.footer.rights}</span>
        <span>[contact@email]</span>
        <span className="flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/mentions-legales" data-testid="footer-legal-link" className="hover:text-gold transition-colors duration-300">{t.footer.legal}</Link>
          <Link to="/confidentialite" data-testid="footer-privacy-link" className="hover:text-gold transition-colors duration-300">{t.footer.privacy}</Link>
          <button type="button" data-testid="footer-cookies-btn" onClick={openCookiePreferences} className="uppercase hover:text-gold transition-colors duration-300">{t.footer.cookies}</button>
          <Link to="/brand" data-testid="footer-brand-link" className="hover:text-gold transition-colors duration-300">{t.footer.brand}</Link>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-gold transition-colors duration-300">{t.footer.admin}</Link>
        </span>
      </div>
    </footer>
  );
};
